import {
  ChangeDetectionStrategy,
  Component,
  ElementRef,
  EventEmitter,
  Input,
  NgZone,
  Output,
  ViewChild,
} from '@angular/core';
import {ReactBaseComponent} from '../../../react/base/react-base.component';
import {CustomerRestoreButton} from '../../../react/customers/restore/customer-restore-button';

const containerElementName = 'reactCustomerRestoreButton';

@Component({
  selector: 'customer-restore-button',
  template: `<div class="inline-block" #${containerElementName}></div>`,
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: true,
})
export class CustomerRestoreButtonReactComponent extends ReactBaseComponent {
  @ViewChild(containerElementName, {static: false}) containerRef: ElementRef;
  @Input() label?: string;
  @Input() customerId: number;
  @Input() customerName: string;
  @Output() restored = new EventEmitter<void>();

  constructor(private ngZone: NgZone) {
    super();
  }

  restoredEmit(): void {
    this.ngZone.run(() => {
      this.restored.emit();
    });
  }

  protected override renderComponent() {
    return <CustomerRestoreButton label={this.label}
                                  customerId={this.customerId}
                                  customerName={this.customerName}
                                  restored={() => this.restoredEmit()}/>;
  }
}
